import React, { useCallback, useMemo, useState } from "react";
import cx from "classnames";
import { Collapse } from "reactstrap";
import { convertFAMs } from "utils/wizardHelpers/wizardHelpers";
import { Icon } from "components";
import { SummaryListItemIconBtn } from "components/SummaryListItem";
import { FieldAppModule } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardResult/ToplogySummary/FieldAppModule";
import {
  useSelectedTopologyItemId,
  useWizardActions,
} from "stores/wizardStore";
import styles from "../WizardResult.module.scss";

export const SwitchComponent = React.memo(
  ({ connectedByTopBracketChildren, id, ...rest }) => {
    const [isOpen, setIsOpen] = useState(true);

    const splitByGroupsFAMs = useMemo(
      () =>
        connectedByTopBracketChildren &&
        convertFAMs(connectedByTopBracketChildren),
      [connectedByTopBracketChildren],
    );

    const { setSelectedTopologyItemId } = useWizardActions();
    const selectedTopologyItemId = useSelectedTopologyItemId();

    const handleSetSideBarId = useCallback(
      (idToSet) => {
        setSelectedTopologyItemId(idToSet);
      },
      [setSelectedTopologyItemId],
    );

    const handleItemClick = useCallback(
      (e) => {
        handleSetSideBarId(id);
        e.stopPropagation();
      },
      [handleSetSideBarId, id],
    );

    const hasChildren =
      rest.rightPlacedChildren?.length ||
      rest.chainedChildren?.length ||
      rest.connectedByTopBracketChildren?.length;
    const handleToggle = useCallback(() => setIsOpen((val) => !val), []);

    return (
      <div onClick={handleItemClick}>
        <div
          className={cx(
            "d-flex w-100 justify-content-start align-items-center border-bottom ps-2_5",
            styles.item,
            {
              "bg-gray-200": selectedTopologyItemId === id,
            },
          )}
        >
          {hasChildren && (
            <Icon
              onClick={handleToggle}
              iconName={
                isOpen ? "chevron-down-regular" : "chevron-right-regular"
              }
              className="icon-16 me-2_5 cursor-pointer"
            />
          )}
          <div className="w-80 d-flex flex-column ms-2">
            <div className="fw-bolder fs-md">{rest.title}</div>
            <div className="text-truncate text-gray-400">
              {rest.presentation}
            </div>
          </div>
          <div className="d-flex flex-nowrap w-20 h-auto">
            {/* TODO: when BE-AB will deliver us a data about menuActions, then we may simplify that notation */}
            {
              // TODO: forthcoming feature (hidden acc US-20779) commented code was replaced by []
              // [...actionItemsList]
              //   .slice(1, actionItemsList.length)
              [].map((item, idx) => (
                <SummaryListItemIconBtn
                  key={idx}
                  item={item}
                  {...rest}
                  idx={idx}
                />
              ))
            }
          </div>
        </div>

        <Collapse isOpen={isOpen}>
          {rest.rightPlacedChildren?.map((item, key) => (
            <FieldAppModule
              SwitchComponent
              key={key}
              {...item}
              setSideBarId={handleSetSideBarId}
              isTopology
            />
          ))}
          {rest.sameLayer?.map((item, key) => (
            <SwitchComponent key={key} {...item} isTopology />
          ))}
          {splitByGroupsFAMs?.map((item, key) => (
            <div key={key}>
              {item.map((fam) => (
                <FieldAppModule
                  {...fam}
                  key={fam.id}
                  isTopology
                  setSideBarId={handleSetSideBarId}
                />
              ))}
            </div>
          ))}
          {rest.chainedChildren?.map((item) => (
            <FieldAppModule
              key={item.id}
              {...item}
              isTopology
              setSideBarId={handleSetSideBarId}
            />
          ))}
        </Collapse>
      </div>
    );
  },
);
